import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteContext = createContext({ content: null });

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios.get(`${API}/content`).then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return <SiteContext.Provider value={{ content }}>{children}</SiteContext.Provider>;
};

export const useSiteContent = () => useContext(SiteContext);
